
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import Combobox from '../../../core/components/Generics/Combobox/Combobox.vue';
import { ComboSelectedOption } from '../../../core/components/Generics/Combobox/Combobox';

@Component({
  components: { 
    Combobox
  },
})
export default class ColorQuantitySelector extends Vue {
  @Prop({ default: null }) value!: ComboSelectedOption | null;
  @Prop({ default: 3 }) minValue!: number;
  @Prop({ default: 10 }) maxValue!: number;

  get scaleOptions() {
    const options: Array<{id: number, value: string}> = [];
    for (let i = this.minValue; i <= this.maxValue; i++) {
      options.push({
        id: i,
        value: i.toString()
      });
    }
    return options;
  }

  handleSelection(selectedOption: ComboSelectedOption) {
    this.$emit('input', selectedOption);
  }

  @Emit('open')
  onComboboxOpen() {}

  @Emit('close')
  onComboboxClose() {}

  @Emit('input')
  input(value: ComboSelectedOption) {
    return value;
  }
}
